export enum RoundingStrategy {
  up = 'up',
  down = 'down',
  default = 'default',
}

export type PriceFormattingOptions = {
  /** Max number of decimals to show */
  maxDecimals: number;
  /** Min number of decimals to show */
  minDecimals: number;
  /** Use relative rounding for more user friendly prices */
  useRelativeRounding: boolean;
  /** Is the price represented as cents or dollars? */
  isPriceGivenAsCents?: boolean;
  /** Use a given rounding strategy to round the final value (used for decimal-less currency like JPY) */
  roundingStrategy?: RoundingStrategy;
};
